<template>
  <div
    class="card"
    style="border-top-left-radius: 0; border-top-right-radius: 0"
  >
    <div class="card-header">
      <div class="row mx-0 align-items-center w-100">
        <h4 class="col px-0 flex align-items-center w-100 mb-0">
          Produk Terjual

          <b-spinner
            v-if="isLoading"
            small
            label="Spinning"
            class="ml-50 mb-25"
          />
        </h4>

        <div class="col-auto px-0">
          <div class="d-flex gap-2">
            <button
              class="btn btn-primary d-flex align-items-center"
              :disabled="!transactionItems.data.length || isLoading"
              @click="exportToCsv"
            >
              <feather-icon
                icon="DownloadIcon"
                size="18"
                class="mr-1"
              />

              Export CSV
            </button>
            <button
              class="btn btn-success d-flex align-items-center"
              :disabled="!transactionItems.data.length || isLoading"
              @click="exportToExcel"
            >
              <feather-icon
                icon="FileTextIcon"
                size="18"
                class="mr-1"
              />

              Export Excel
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- Filters -->
      <div class="row mb-2">
        <!--        <div class="col-md-3">-->
        <!--          <b-form-group label="Brand">-->
        <!--            <v-select-->
        <!--              :value="selectedMerchant"-->
        <!--              :options="merchantList"-->
        <!--              label="name"-->
        <!--              :filterable="false"-->
        <!--              :disabled="isLoadingTotalSalesReport || isLoadingDailySalesReport"-->
        <!--              @search="onSearchMerchant"-->
        <!--              @input="value => $store.commit('brandLeaderboard/SET_SELECTED_MERCHANT', value)"-->
        <!--              @input.self="handleFilterChange"-->
        <!--            />-->
        <!--          </b-form-group>-->
        <!--        </div>-->
        <div class="col-md-3">
          <b-form-group label="Dari Tanggal">
            <b-form-datepicker
              :value="startDate"
              :disabled="isLoading"
              @input="value => $store.commit('brandLeaderboard/SET_START_DATE', value)"
              @input.self="handleFilterChange"
            />
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Hingga Tanggal">
            <b-form-datepicker
              :value="endDate"
              :disabled="isLoading"
              @input="value => $store.commit('brandLeaderboard/SET_END_DATE', value)"
              @input.self="handleFilterChange"
            />
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-checkbox
            id="checkbox-1"
            :checked="showAllTransactionItems"
            name="checkbox-1"
            style="margin-top: 37px"
            :disabled="isLoading"
            @input="value => $store.commit('brandLeaderboard/SET_SHOW_ALL_TRANSACTION_ITEMS', value)"
            @input.self="fetchMerchants"
          >
            Tampilkan semua item <span v-if="pagination.total">({{ pagination.total }})</span>
          </b-form-checkbox>
        </div>
      </div>

      <!-- Merchants Table -->
      <div
        class="table-responsive overflow-auto"
      >
        <table
          class="table table-bordered"
          :class="{'opacity-50': isLoading}"
          style="max-height: 1000px"
        >
          <thead>
            <tr>
              <th
                class="sticky-top px-1"
                style="z-index: 0"
              >
                Transaksi
              </th>
              <th
                class="sticky-top px-1"
                style="z-index: 0"
              >
                Brand
              </th>
              <th
                class="sticky-top px-1"
                style="z-index: 0"
              >
                Produk & Varian
              </th>
              <th
                class="sticky-top px-1"
                style="z-index: 0"
              >
                Harga
              </th>
              <th
                v-if="false"
                class="sticky-top px-1"
                style="z-index: 0"
              >
                Kategori
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in transactionItems.data"
              :key="item.merchant_id"
            >
              <td class="px-1">
                <div>{{ item.invoice_number }}</div>
                <small>{{ formatDate(item.created_at) }} {{ formatTime(item.created_at) }}</small>
              </td>
              <td class="px-1">
                {{ item.brand }}
              </td>
              <td
                class="px-1"
                style="width: 50%;"
              >
                {{ item.product }}<span v-if="item.variant"> - {{ item.variant }}</span>
              </td>
              <td class="px-1">
                <div>{{ toCurrency(item.price) }}</div>
                <small
                  v-if="item.compare_price"
                  style="text-decoration: line-through"
                >{{ toCurrency(item.compare_price) }}</small>
              </td>
              <td
                v-if="false"
                class="px-1"
              >
                {{ item.parent_category }}<span v-if="item.category"> → {{ item.category }}</span>
              </td>
            </tr>
            <tr v-if="!transactionItems.data.length">
              <td
                colspan="4"
                class="text-center"
              >
                Tidak ada data untuk ditampilkan.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-between align-items-center mt-3 mb-0.5">
        <div>
          Menampilkan {{ pagination.from || 0 }}-{{ calculateTo }} dari {{ pagination.total || 0 }} baris
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          :limit="5"
          align="center"
          class="mb-0"
          @change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  BFormDatepicker,
  BFormCheckbox,
  BPagination,
  BFormGroup,
  BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapState } from 'vuex'
import * as XLSX from 'xlsx'

export default {
  components: {
    BFormDatepicker,
    BFormCheckbox,
    BFormGroup,
    BPagination,
    BSpinner,
  },
  data() {
    return {
      currentPage: 1,
      isLoading: false,
      // Column mapping for human-readable headers
      columnMapping: {
        no: 'No',
        customer_name: 'Customer Name',
        brand: 'Merchant',
        product: 'Description',
        variant: 'Variant',
        parent_category: 'Category',
        category: 'Sub Category',
        created_at: 'Invoice Date',
        invoice_number: 'Invoice Number',
        period: 'Period',
        compare_price: 'Price per item',
        quantity: 'Quantity',
        subtotal: 'Total Sales Amount',
        discount: 'Sales Discount dari Miniapoly',
        price: 'After discount',
        delivery_courier: 'Courier',
        delivery_service: 'Courier Service',
        delivery_fee: 'Delivery Fee',
        delivery_insurance_fee: 'Insurance Fee',
        mini_point: 'Mini Point',
        source: 'Source',
        billed_total: 'Billed Total',
        transaction_total: 'Transaction Total',
      },
    }
  },
  computed: {
    ...mapState('brandLeaderboard', [
      'showAllTransactionItems',
      'transactionItems',
      'startDate',
      'endDate',
    ]),
    calculateTo() {
      const to = this.pagination.from + this.transactionItems.data.length - 1
      return to || 0
    },
    pagination() {
      return {
        ...this.transactionItems.meta,
        per_page: this.showAllTransactionItems ? 1000 : 10,
      }
    },
  },
  mounted() {
    if (!this.transactionItems || !this.transactionItems.data || !this.transactionItems.data.length) {
      this.fetchMerchants()
    }

    if (this.transactionItems.meta.current_page) {
      this.currentPage = this.transactionItems.meta.current_page
    }
  },
  methods: {
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async fetchMerchants() {
      const startDate = new Date(this.startDate)
      const endDate = new Date(this.endDate)

      if (startDate > endDate) {
        return
      }

      this.isLoading = true

      try {
        if (this.showAllTransactionItems) {
          await this.delay(5000)
        } else {
          await this.delay(500)
        }

        const response = await this.$http.get('/v5/report/transaction-items', {
          params: {
            page: this.currentPage,
            limit: this.pagination.per_page,
            start_date: this.startDate,
            end_date: this.endDate,
          },
        })

        this.$store.commit('brandLeaderboard/SET_TRANSACTION_ITEMS', response.data)
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Gagal memuat data',
            icon: 'BellIcon',
          },
        })
      } finally {
        this.isLoading = false
      }
    },

    // reset other tab data to force reload data from API
    handleFilterChange() {
      // tab 1
      this.$store.commit('brandLeaderboard/RESET_MERCHANT_LEADERBOARD')
      // tab 2
      this.$store.commit('brandLeaderboard/RESET_TOTAL_REPORT')
      this.$store.commit('brandLeaderboard/RESET_DAILY_REPORT')
      this.fetchMerchants()
    },

    handlePageChange(page) {
      this.currentPage = page
      this.fetchMerchants()
    },

    calculateRank(index) {
      return ((this.pagination.current_page - 1) * this.pagination.per_page) + index + 1
    },

    formatCurrency(amount) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
      }).format(amount || 0)
    },

    getExportDataForReport() {
      const headers = Object.keys(this.columnMapping)
      const dataMatrix = []

      // Add headers as first row
      const readableHeaders = headers.map(header => this.columnMapping[header] || header)
      dataMatrix.push(readableHeaders)

      // Add data rows
      this.transactionItems.data.forEach((item, index) => {
        const row = headers.map(header => {
          if (header === 'no') {
            return this.calculateRank(index)
          }
          if (header === 'created_at') {
            return this.formatDateDMY(item[header])
          }
          if (header === 'period') {
            return this.formatDateMonthOnly(item.created_at)
          }
          if (header === 'subtotal') {
            return (item.compare_price || 0) * (item.quantity || 1)
          }
          if (header === 'discount') {
            return (item[header] || 0) * (item.quantity || 1)
          }
          if (header === 'price') {
            return (item[header] || 0) * (item.quantity || 1)
          }
          if (header === 'delivery_courier' || header === 'delivery_service') {
            return item[header] ? String(item[header]).toUpperCase() : ''
          }
          if (header === 'source') {
            return item[header] ? String(item[header]).charAt(0).toUpperCase() + String(item[header]).slice(1).toLowerCase() : ''
          }

          const value = item[header]
          return value !== undefined && value !== null ? value : ''
        })
        dataMatrix.push(row)
      })

      return dataMatrix
    },

    exportToCsv() {
      if (!this.transactionItems.data.length) return

      const dataMatrix = this.getExportDataForReport()

      const csvContent = dataMatrix.map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(',')).join('\n')

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)

        if (this.showAllTransactionItems) {
          link.setAttribute('download', `Sales Report Transaction Products ${this.startDate}-${this.endDate}.csv`)
        } else {
          link.setAttribute('download', `Sales Report Transaction Products ${this.startDate}-${this.endDate} Page-${this.currentPage}.csv`)
        }
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },

    formatDateDMY(dateString) {
      if (!dateString) return ''

      const date = new Date(dateString)
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()

      return `${day}/${month}/${year}`
    },

    formatDateMonthOnly(dateString) {
      if (!dateString) return ''

      const date = new Date(dateString)
      return date.toLocaleString('en-US', { month: 'long' })
    },

    exportToExcel() {
      if (!this.transactionItems.data.length) return

      const worksheetData = this.getExportDataForReport()

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new()
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)

      // Set column widths for better readability
      worksheet['!cols'] = [
        { width: 4 }, // No
        { width: 20 }, // Customer Name
        { width: 25 }, // Merchant
        { width: 40 }, // Description
        { width: 20 }, // Variant
        { width: 20 }, // Category
        { width: 20 }, // Sub Category
        { width: 15 }, // Invoice Date
        { width: 20 }, // Invoice Number
        { width: 10 }, // Period
        { width: 15 }, // Price per Item
        { width: 15 }, // Quantity
        { width: 15 }, // Total Sales Amount
        { width: 25 }, // Sales Discount
        { width: 15 }, // After Discount
        { width: 15 }, // Courier
        { width: 15 }, // Courier Service
        { width: 15 }, // Delivery Fee
        { width: 15 }, // Insurance Fee
        { width: 15 }, // Mini Point
        { width: 15 }, // Source
        { width: 20 }, // Billed Total
        { width: 20 }, // Transaction Total
      ]

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Transaction Items')

      // Generate filename
      let filename
      if (this.showAllTransactionItems) {
        filename = `Sales Report Transaction Products ${this.startDate}-${this.endDate}.xlsx`
      } else {
        filename = `Sales Report Transaction Products ${this.startDate}-${this.endDate} Page-${this.currentPage}.xlsx`
      }

      // Write and download the file
      XLSX.writeFile(workbook, filename)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style scoped>
.card {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.gap-2 {
  gap: 0.5rem;
}
</style>
